/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


// (function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.


//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container ———————— ↓');
//       console.log(container);
//       console.log('Variant —————————— ↓');
//       console.log(variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart ———————————— ↓');
//       console.log(cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {
//     console.log('theme:cart:init');
//     console.log(e);
//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // the lock event must set `detail` to the modal or drawer body so the 
//   // scroll locking code knows what element should maintain scoll. 
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.
// })();


document.addEventListener('DOMContentLoaded', () => {
  scrollBlogTagsPosition();
  blogPostLazyLoading();
  
  var lightboxes = initLightboxes();
})

document.addEventListener('scroll', blogPostLazyLoading);

function initLightboxes(action = false, lightboxes) {
  if (action === 'reload') {
    lightboxes.forEach(lb => {
      lb.reload();
    })
  } else {
    return [
      GLightbox({selector: '.glightbox'}), 
      GLightbox({selector: '.glightbox-title'})
    ];
  }
  
}

function scrollBlogTagsPosition() {
  const tagsWrapper = document.querySelector('.blog__tags-wrapper');
  const tagActive = tagsWrapper?.querySelector('.blog__tag--active');
  if (tagActive) {
    tagsWrapper.scrollLeft = tagActive.getBoundingClientRect().left - tagsWrapper.getBoundingClientRect().left - tagsWrapper.scrollLeft;
  }
}

function blogPostLazyLoading() {
  const postsList = document.querySelector('.lazy-loading-posts');
  const loadMoreWrapper = document.querySelector('.load-more__wrapper');


  if (loadMoreWrapper) {
    const loadMoreLink = loadMoreWrapper.querySelector('.load-more__link');
    const loadMorePos = loadMoreLink.getBoundingClientRect().top;

    if (isElementVisible(loadMoreLink)) {
      loadMoreWrapper.remove();
      document.removeEventListener('scroll', blogPostLazyLoading);

      fetch(loadMoreLink.getAttribute('href'))
        .then(responce => responce.text())
        .then(text => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");
          const newPostsList = doc.querySelector('.lazy-loading-posts');
          postsList.insertAdjacentHTML("beforeend", newPostsList.innerHTML);
        }).then(data => {
          initLightboxes('reload', lightboxes);

          setTimeout(() => {
            document.addEventListener('scroll', blogPostLazyLoading);
          }, 0);
        });
    }
  }

  function isElementVisible(el) {
    const rect = el.getBoundingClientRect();
    const vWidth = window.innerWidth || document.documentElement.clientWidth;
    const vHeight = window.innerHeight || document.documentElement.clientHeight;
  
    return (
      rect.top >= 0 &&
      rect.bottom <= vHeight &&
      rect.left >= 0 &&
      rect.right <= vWidth
    );
  }
}
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="http"]').forEach(function(link) {
    if (link.hostname !== window.location.hostname) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    }
  });
});